export default class CaseConflictError extends Error {}